import type { Theme } from '@mui/material/styles'

// containerEdge is the edge of an outlined control, or of a container that
// must read as one against white: MUI's grey ramp, light or dark (the
// divider token is too faint to tell a line card from the condition cards
// inside it).
export const containerEdge = (theme: Theme): string =>
  theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300]
